import { FC, PropsWithChildren } from 'react';

export interface Button {
  type?: 'button' | 'submit' | 'reset';
}

export const Button: FC<PropsWithChildren<Button>> = ({ children, type }) => {
  return (
    <button
      className="h-full w-full rounded-lg bg-primary py-2 font-semibold text-white"
      type={type}
    >
      {children}
    </button>
  );
};
